export default "__VITE_ASSET__BjfT6aaZ__"